'use strict';
import map from 'lodash/map';
import * as activeTimersActions from './activeTimersActions';

export * from './activeTimersActions';
export * from './activeTimersQueueActions';
export * from './timerExportActions';

export const storageActions = map(activeTimersActions, action => action.TYPE);



// WEBPACK FOOTER //
// ./src/js/timers/actions/index.js